import defaultAxios from "axios";
import toast from "react-hot-toast";

export const ROOT_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const axios = defaultAxios.create({
  baseURL: ROOT_URL,
  headers: {
    "X-Source": "customer-web",
  },
});

axios.interceptors.response.use(
  function (response) {
    if (response?.data?.message) {
      toast.success(response.data.message);
    }
    return response;
  },
  async function (error) {
    // if (
    //     error.response &&
    //     error.response.data &&
    //     error.response.status !== 401
    // ) {
    //     if (error.response.data.error) {
    //         if (error.response.status !== 500) {
    //             displayMessage(error.response.data.error);
    //         }
    //     }
    // }
    if (error.response.status === 401) {
      toast.error("Session expired", { duration: 5000 });
      localStorage.clear();
      // window.location.reload();
    }
    if (error.response.status === 429) {
      toast.error("Please try again in a few minutes...");
    }
    return Promise.reject(error);
  }
);

export const setToken = (token) =>
  (axios.defaults.headers.Authorization = `Token ${token}`);

export const removeToken = () => delete axios.defaults.headers.Authorization;
export default axios;
